import { Box } from "@mui/material";
import HeaderPhoto from "../../assets/images/show_factory_road.jpg";
import PageHeader from "../../components/PageHeader";
import AboutSection from "./components/AboutSection";
import ResearchSection from "./components/ResearchSection";
import StaffSection from "./components/StaffSection";
import BookSection from "./components/BookSection";
import HowToHelpSection from "./components/HowToHelpSection";

function Home() {
  return (
    <Box>
      <PageHeader
        image={HeaderPhoto}
        title="Advancing Conservation Through Beauty, Science, and Place"
        header="Conservation Research Institute"
      />

      <AboutSection />
      <HowToHelpSection />
      <ResearchSection />
      <StaffSection />
      <BookSection />
    </Box>
  );
}

export default Home;
